import { render, staticRenderFns } from "./rewardBuildPartnersEdit.vue?vue&type=template&id=51cde49f&scoped=true&"
import script from "./rewardBuildPartnersEdit.vue?vue&type=script&lang=js&"
export * from "./rewardBuildPartnersEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cde49f",
  null
  
)

export default component.exports